import React, { Component } from "react";
import PropTypes from "prop-types";

export class Question extends Component {
  constructor (props) {
    super(props);

    this.state = {
      question: this.props.question
    };
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this.props.question 
      && this.props.question.questionId !== prevProps.question.questionId 
    ) {
      this.setState({
        question: this.props.question
      });
    }
  }

  render () {
    let {
      question
    } = this.props;

    if (!question) return null;

    return (
      <div>
        <h3>{question.title}</h3>
        <div className={"questions-body"}>
          <ul>
            {this._renderBody(question)}
          </ul>
        </div>
      </div>
    );
  }

  // --------------------------------------------------------------------

  _renderBody = (question) => {
    switch (question.typeId) {
      case 1:
        return this._inputDropdown(question);
      case 2:
        return this._inputDefault(question);
      case 3:
      case 6:
        return this._inputSingleOption(question);
      case 4:
        return this._inputMultipleOption(question);
      case 5:
        return this._inputTextarea(question);
      default:
        return null;
    }
  };

  _inputDefault = (question) => {
    return (
      <li>
        <span className={"control-group"}>
          <span className={"controlls level-2"} style={{width:"100%"}}>
            <input type={"text"} 
                   className={"option"} 
                   id={`question-${question.questionId}`} 
                   value={question.options[0].textValue}
                   onChange={this._updateDefault}
                   style={{width:"100%"}}/>
          </span>
        </span>
      </li>
    );
  };

  _inputDropdown = (question) => {
    return null;
  };

  _inputSingleOption = (question) => {
    question.options.sort((a, b) => {
      return a.optionOrder - b.optionOrder;
    });

    return question.options.map((item, key) => {
      if (!item.enabled) return null;
      
      return (
        <li key={key}>
          <span className={"control-group"}>
            <span className={"controlls"}>
              <input 
                type={"radio"} 
                className={"option"} 
                checked={item.is_selected}
                onChange={this._updateSingleOption(key)}
                value={item.optionId}
                id={`question-${question.questionId}-${key}`}/>
              <label htmlFor={`question-${question.questionId}-${key}`}>
                <span>
                  {item.optionText}
                </span>
              </label>
            </span>
          </span>
        </li>
      );
    });
  };

  _inputMultipleOption = (question) => {
    question.options.sort((a, b) => {
      return a.optionOrder - b.optionOrder;
    });

    return question.options.map((item, key) => {
      if (!item.enabled) return null;

      let checked = item.is_selected;
      
      return (
        <li key={key}>
          <span className={"control-group"}>
            <span className={"controlls"}>
              <input 
                type={"checkbox"} 
                className={"option"} 
                checked={checked}
                onChange={this._updateMultipleOption(key)}
                value={item.optionId}
                id={`question-${question.questionId}-${key}`}/>
              <label htmlFor={`question-${question.questionId}-${key}`}>
                <span>
                  {item.optionText}
                </span>
              </label>
            </span>
          </span>
        </li>
      );
    });
  };

  _inputTextarea = (question) => {
    return (
      <li>
        <span className={"control-group"}>
          <span className={"controlls level-2"} style={{width:"100%"}}>
            <textarea 
              id={`question-${question.questionId}`} 
              style={{width:"100%"}} 
              onChange={this._updateDefault}
              value={question.options[0].textValue}/>
          </span>
        </span>
      </li>
    );
  };

   _updateDefault = (e) => {
    e.preventDefault();
    
    let value = (e.target.value !== null && e.target.value !== undefined)
      ? e.target.value 
      : "";

    let {
      question
    } = this.state;

    question.options[0].is_selected = (value.length > 0);
    question.options[0].textValue = value;

    this.props.onUpdate(question);

    this.setState({
      question: question
    });

    this.forceUpdate();
  };

  _updateSingleOption = (index) => {
    return () => {
      let {
        question
      } = this.state;

      for (let n = 0; n < question.options.length; n++) {
        question.options[n].is_selected = false;
      }
      
      question.options[index].is_selected = true;

      this.props.onUpdate(question);

      this.setState({
        question: question
      });

      this.forceUpdate();
    };
  };

  _updateMultipleOption = (index) => {
    return () => {
      let {
        question
      } = this.state;

      question.options[index].is_selected = !question.options[index].is_selected;

      this.props.onUpdate(question);

      this.setState({
        question: question
      });

      this.forceUpdate();
    }
  };
}

Question.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  question: PropTypes.shape({
    typeId: PropTypes.number,
    isShuffled: PropTypes.bool,
    minCount: PropTypes.number,
    options: PropTypes.array,
    cssStyle: PropTypes.string,
    minAnswers: PropTypes.number,
    onClick: PropTypes.any,
    cssClass: PropTypes.string,
    summary: PropTypes.string,
    dateUpdated: PropTypes.any,
    onBlur: PropTypes.any,
    maxCount: PropTypes.number,
    formId: PropTypes.number,
    title: PropTypes.string,
    regex: PropTypes.string,
    onChange: PropTypes.any,
    answerCount: PropTypes.number,
    maxAnswers: PropTypes.number,
    questionType: PropTypes.number,
    questionOrder: PropTypes.number,
    dateCreated: PropTypes.number,
    onFocus: PropTypes.any,
    hint: PropTypes.string,
    questionId: PropTypes.number,
    status: PropTypes.number
  }).isRequired
};
